<template>
    <div>
        <div class="loading" v-if="loading"><v-progress-circular indeterminate color="#de5d0a"></v-progress-circular>
        </div>
        <div v-else class="choose-box">
            <div class="containers">
                <div style="padding-bottom: 12px;">
                    <span style="font-size: 14px; font-weight: 500;">{{seatType == 2 ? $t('message.selectYourBed') : $t('message.selectSeat') }}</span>
                </div>
                <div class="select-seat ">
                    <div class="seat-available">
                        <div class="seat-colors-gray"></div>
                        <div style="padding-left: 10px;">{{ $t('message.available') }}</div>
                    </div>
                    <div class="selected">
                        <div class="seat-colors-blue"></div>
                        <div style="padding-left: 10px;">{{ $t('message.selected') }}</div>
                    </div>
                    <div class="seat-unavailable">
                        <div class="seat-colors-green"></div>
                        <div style="padding-left: 10px;">{{ $t('message.unavailable') }}</div>
                    </div>
                </div>
            </div>

            <div class="container-table containers">
                <table class="table_reposive">
                    <tr v-for="(colunm, index) in colunms" :key="index">
                        <template v-for="(cell, index1) in arraydata[index]['col']">
                            <td :key="index1"
                                :colspan="cell.attr && cell.attr.colspan ? Number(cell.attr.colspan) : 1"
                                style="text-align: center;width: 30px;">
                                <div v-if="cell.label != ''"
                                    style="margin: 0px;padding: 0;width: 100%">
                                    <div style="margin: 0;padding: 0;"
                                        v-if="!(cell.label == 'Down Stair' || cell.label == 'Up Stair' || cell.label == 'Capitain' || cell.label == 'Toilet' || cell.label == 'Hostess' || cell.label == 'Door')">
                                        <div style="margin: 0;padding: 0;"
                                            v-if="!(getUnva(cell.value))">
                                            <img v-if="!selectedSeat || !(getSeat(cell.value))"
                                                @click="addClick(cell.value, cell.label)"
                                                :src="seatType == 2 ? require('@/assets/seats/BED 1.png') : require('@/assets/seats/Chair 1.png')"
                                                style="width:40px" alt="">
                                        </div>
                                    </div>
                                    <img v-if="getUnva(cell.value)"
                                        :src="seatType == 2 ? require('@/assets/seats/BED 3.png') : require('@/assets/seats/Chair 3.png')"
                                        style="width:40px" alt="">
                                    <img v-if="selectedSeat && getSeat(cell.value)"
                                        @click="deleteSeat(cell.value, cell.label)"
                                        :src="seatType == 2 ? require('@/assets/seats/BED 2.png') : require('@/assets/seats/Chair 2.png')"
                                        style="width:40px" alt="">
                                </div>
                                <img v-if="cell.label == ''"
                                    :src="require('@/assets/seats/invisible.svg')" style="width:20px;" alt="">

                                <p v-if="!(cell.label == 'Hostess' || cell.label == 'Capitain')"
                                    style="font-size: 12px;color: #000000;font-weight: 600; margin-top: -10px;margin-bottom: 0; white-space: nowrap;">
                                    {{ cell.label == 'Down Stair' ? $t('message.downstair') :
                                        cell.label == 'Up Stair' ? $t('message.upstair') :
                                            cell.label == 'Toilet' ? $t('message.toilet') :
                                                cell.label == 'Door' ? $t('message.door') :
                                                    cell.label }}<span>{{ getGender(cell.value) }}</span>
                                </p>

                                <img v-if="cell.label == 'Capitain'"
                                    :src="require('@/assets/seats/captain.png')" style="width:30px;" alt="">

                                <img v-if="cell.label == 'Hostess'"
                                    :src="require('@/assets/seats/hostess.png')" style="width:30px;" alt="">
                            </td>
                        </template>
                    </tr>
                </table>
            </div>

            <!-- button sticky -->
            <div class=" botton-sticky">
                <div v-if="selectedSeat" class="btn_edits_seat ">
                    <!-- <div class="containers"> -->
                    <div>
                        <p style="font-size: 16px; font-weight: 600; margin-bottom: 0%;">{{seatType == 2 ? $t('message.selectedBed') : $t('message.selectedSeat')
                            }} ({{ seats.length }})</p>
                        <span style="font-size: 16px;  font-weight: 600;">{{ seatname.join(', ') }}</span>
                    </div>
                    <div style="font-size: 20px; font-weight: 600;" class="continue" @click="checkAndContinue">
                        {{ $t('message.continue') }}
                    </div>
                </div>

                <!-- </div> -->
            </div>

        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from "axios";
export default {
    data() {
        return {
            loading: true,
            info: null,
            errored: false,
            rows: 0,
            colunms: 0,
            arraydata: [],
            unavailables: [],
            gender: [],
            seats: [],
            seatname: [],
            selectedSeat: false,
            unava: false,
            seatType: '',
        }
    },
    methods: {
        checkAndContinue() {
            if (!this.seats || this.seats.length === 0) {
                alert(this.$t('message.pleaseSelectSeat'));
                return;
            }
            this.getBtnthen();
        },
        getBtnthen() {
            localStorage.setItem('seat', this.seats);
            localStorage.setItem('seatlabel', this.seatname);
            if (localStorage.getItem('dateTo') != null) {
                this.$router.push("bus-list-back");
            } else {
                this.$router.push("/passenger-info");
            }
        },
        addClick(value, label) {
            this.seats.push(value);
            this.seatname.push(label);
            this.selectedSeat = true;

            let calTotal = this.seats.length;
            let seatP = localStorage.getItem('price');
            let totalAmount = parseFloat(calTotal * seatP);
            this.resultTotal = totalAmount;
            localStorage.setItem('resultTotal', this.resultTotal);
        },
        getUnva(item) {
            let check = true;
            for (let j = 0; j < this.unavailables.length; j++) {
                if (item == this.unavailables[j]) {
                    check = true
                    break;
                } else {
                    check = false;
                }
            }
            if (this.unavailables.length == 0) {
                return false;
            }
            return check;
        },
        getGender(item) {
            let genStr = "";
            for (let j = 0; j < this.unavailables.length; j++) {
                if (item == this.unavailables[j]) {
                    if (this.gender[j] == '1') {
                        genStr = "(M)";
                    } else {
                        genStr = "(F)";
                    }
                    break;
                } else {
                    genStr = "";
                }
            }
            if (this.unavailables.length == 0) {
                return genStr;
            }
            return genStr;
        },

        getSeat(item) {
            let check = true;

            for (let j = 0; j < this.seats.length; j++) {

                if (item == this.seats[j]) {
                    check = true
                    break;
                } else {
                    check = false;
                }
            }

            return check;
        },
        deleteSeat(value, label) {

            if (this.seats.length == 1) {
                this.selectedSeat = false;
            }

            for (let j = 0; j < this.seats.length; j++) {
                if (this.seats[j] == value) {
                    this.seats.splice(j, 1);
                }
            }

            for (let j = 0; j < this.seatname.length; j++) {
                if (this.seatname[j] == label) {
                    this.seatname.splice(j, 1);
                }
            }

            if (this.seats.length == 0) {
                this.selectedSeat = false;
            }

            if (this.seatname.length == 0) {
                this.selectedSeat = false;
            }

        },

        // Get schedule data to retrieve transportationType
        async getScheduleData() {
            const data = {
                date: localStorage.getItem('dateFrom'),
                destinationFrom: localStorage.getItem('departureFromId'),
                destinationTo: localStorage.getItem('destinationToId'),
                nationally: localStorage.getItem('selectNational'),
                type: localStorage.getItem('types'),
                session: localStorage.getItem('session_start_login'),
            };

            const url = this.$url + `schedule/listByDate`;

            const config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url,
            };

            axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        const res = response.data;
                        if (res.header.result === true && res.header.statusCode === 200) {
                            const scheduleData = res.body || [];
                            const journeyId = localStorage.getItem('journeyid');

                            // Find the matching journey and save transportationType
                            const selectedJourney = scheduleData.find(item => item.id == journeyId);
                            if (selectedJourney && selectedJourney.transportationType) {
                                localStorage.setItem('transportationType', selectedJourney.transportationType);
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.error('Failed to fetch schedule data:', error);
                });
        },

        // Get Data From Api Layout
        async getDateLayout() {

            const data = { 'date': localStorage.getItem('dateFrom'), 'journey': localStorage.getItem('journeyid') };
            const url = this.$url + `seat/layout`;

            let config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url
            };
            this.loading = true;
            axios(config).then(response => {
                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.loading = false;
                        this.info = response.data.body;
                        let layout = JSON.parse(this.info[0]['layout']);
                        this.arraydata = JSON.parse(this.info[0]['layout']);
                        this.colunms = layout.length;
                        this.seatType = this.info[0]['seatType'];
                        localStorage.setItem('seatType', this.seatType);

                        this.rows = layout[0]['col'].length;
                        this.getDataUnavailable();
                    } else {
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },

        // Get Data From Api Unavailable
        async getDataUnavailable() {
            const data = { 'date': localStorage.getItem('dateFrom'), 'journey': localStorage.getItem('journeyid') };
            const url = this.$url + `seat/unavailable`;

            let config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url
            };

            axios(config).then(response => {
                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        let data = response.data.body;
                        let size = response.data.body.length;

                        if (response.data.body != 0) {
                            for (let i = 0; i < size; i++) {
                                this.unavailables.push(data[i]['seatNumber']);
                                this.gender.push(data[i]['gender']);
                            }
                        }

                        if (localStorage.getItem('seat') != null) {

                            let arrayNew = localStorage.getItem('seat');
                            let seatArray = arrayNew.split(",");

                            for (let i = 0; i < seatArray.length; i++) {

                                if (seatArray[i] != ',') {
                                    this.seats.push(seatArray[i]);
                                }

                            }
                            this.selectedSeat = true;
                        }

                        if (localStorage.getItem('seatlabel') != null) {

                            let arrayNew = localStorage.getItem('seatlabel');
                            let seatArray = arrayNew.split(",");

                            for (let i = 0; i < seatArray.length; i++) {

                                if (seatArray[i] != ',') {
                                    this.seatname.push(seatArray[i]);
                                }

                            }
                            this.selectedSeat = true;
                        }

                    } else {
                        this.errored = true
                    }

                }

            }).catch(error => {
                console.log(error);
            })
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    },
    created() {
        this.scrollToTop();
        localStorage.removeItem("seatback");
        localStorage.removeItem("seatlabelback");
        if (localStorage.getItem('seat') == null && localStorage.getItem('seatlabel') == null) {
            this.selectedSeat = false;
        }

        // Fetch schedule data to ensure transportationType is available
        this.getScheduleData();

        setTimeout(() => {
            this.getDateLayout();
        }, 1000);
    }
}
</script>

<style scoped>
.choose-box {
    padding-top: 80px;
    /* padding-bottom: 50px; */
    min-height: 70vh;
    background-color: #F0F2F5;
}

.container-table {
    width: 100%;
    padding-bottom: 1rem;
}

.table_reposive {
    width: 100%;
    border: 1px solid #DADDE1;
    border-radius: 12px;
    padding: 1rem;
}

.botton-sticky {
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 10px;
    /* padding-bottom: 10px; */
    z-index: 100;
}

.btn_edits_seat {
    /* margin-top: 20px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    padding: 12px;
    z-index: 100;
    box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.1);
}

.btn_edits_seat .continue {
    padding: 1rem;
    /* border: 1px solid #DADDE1; */
    border-radius: 50px;
    font-weight: 600;
    /* font-size: 16px; */
    color: #ffffff;
    background: #DE5D0A;
    width: 192px;
    text-align: center;
}

.seat-colors-gray {
    width: 14px;
    height: 14px;
    border-radius: 12px;
    background: #D9D9D9;
    padding-right: 10px;
    border: 1px solid #D9D9D9;
}

.seat-colors-blue {
    width: 14px;
    height: 14px;
    border-radius: 12px;
    background: #312783;
    padding-right: 10px;
    border: 1px solid #312783;
}

.seat-colors-green {
    width: 14px;
    height: 14px;
    border-radius: 12px;
    background: #FF0000;
    border: 1px solid #FF0000;
}

.select-seat {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
}


.select-seat .seat-unavailable {
    width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: end;
}

.select-seat .selected {
    width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.select-seat .seat-available {
    width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: start;
}

.select-seat .seat-available,
.selected,
.seat-unavailable div {
    font-size: 14px;
    font-weight: 600;
    color: #1D1D1D;
}
</style>